import React, { useState } from "react";
import { User, Lock, Eye, EyeOff } from "lucide-react";
import '../styles/pages/LoginPage.css';

export default function LoginPage({ onLogin }) {
  const [accessCode, setAccessCode] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const API = process.env.REACT_APP_API_URL || "https://api.anti-bot.ai";
      const res = await fetch(`${API}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: accessCode, password }),
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem('ab_username', data.username);
        localStorage.setItem('ab_phone', data.phone || '');
        onLogin();
      } else {
        setError(data.error || 'שם משתמש או סיסמה שגויים');
        setLoading(false);
      }
    } catch {
      setError('שגיאת חיבור לשרת');
      setLoading(false);
    }
  };

  return (
    <div className="ab-login">
      {/* רקע - וידאו */}
      <video 
        className="ab-bg-video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={`${process.env.PUBLIC_URL}/image/login-video.mp4`} type="video/mp4" />
      </video>

      {/* שכבת כהות */}
      <div className="ab-shade" />

      {/* תוכן */}
      <div className="ab-content">
        {/* השריון */}
        <div className="ab-shield-container">
          <img 
            className="ab-big-shield" 
            src={`${process.env.PUBLIC_URL}/image/brand-shield.png`}
            alt="" 
          />
          
          {/* טופס */}
          <form className="ab-form" onSubmit={onSubmit}>
            {/* כותרת */}
            <h1 className="ab-login-title">Login</h1>

            {/* Username עם אייקון */}
            <div className="ab-input-wrapper">
              <User size={20} className="ab-input-icon" />
              <input
                className="ab-input"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                placeholder="Username"
                autoComplete="username"
                required
              />
            </div>

            {/* Password עם אייקונים */}
            <div className="ab-input-wrapper">
              <Lock size={20} className="ab-input-icon" />
              <input
                className="ab-input ab-input-pass"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                type={showPass ? "text" : "password"}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="ab-eye"
                onClick={() => setShowPass((v) => !v)}
                aria-label={showPass ? "Hide password" : "Show password"}
              >
                {showPass ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {error && <div className="ab-error">{error}</div>}

            <button className="ab-btn" type="submit" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}